import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-shared-tournament-year-filter',
    templateUrl: './shared-tournament-year-filter.component.html',
    styleUrls: ['./shared-tournament-year-filter.component.scss'],
})
export class SharedTournamentYearFilterComponent implements OnInit {
    @Output() onFilterChange: EventEmitter<any> = new EventEmitter();
    filterTournamentYear: string = '2020';

    /**
     * Opções possíveis de seleção nos filtros
     */
    filterTournamentYearOptions = [
        {
            label: '2020',
            filter: '2020',
        },
        {
            label: '2019',
            filter: '2019', // TODO: só exemplo, alterar
        },
        {
            label: '2018',
            filter: '2018',
        },
        {
            label: '2017',
            filter: '2017',
        },
        {
            label: '2016',
            filter: '2016',
        },
    ];

    constructor() {}

    ngOnInit(): void {}

    changeFilter({ filter }) {
        this.filterTournamentYear = filter;
        this.onFilterChange.emit(filter);
    }
}
